import { jsx as _jsx } from "react/jsx-runtime";
import React, { useRef } from 'react';
import { SimpleTreeView } from '@mui/x-tree-view';
import { courseItemStatus } from '../../course/constants';
import StyledTreeItem from './StyledTreeItem';
const SectionsPanel = ({ settings: { sectionExpansionOption, showLessonType = true } = { sectionExpansionOption: 'firstOpen' }, sections, selectedItem, setSelectedItem, courseProgress, }) => {
    const [expanded, setExpanded] = React.useState([]);
    const firstRender = useRef(true);
    const expansionAction = useRef(sectionExpansionOption);
    const getViewStatus = (section) => {
        if (!courseProgress) {
            return courseItemStatus.NOT_STARTED;
        }
        if (courseProgress?.lessonProgress
            && Object.keys(courseProgress.lessonProgress).length
            && courseProgress.lessonProgress[section.id]) {
            if (courseProgress.lessonProgress[section.id].isCompleted) {
                return courseItemStatus.DONE;
            }
            if (courseProgress.lessonProgress[section.id].isStarted) {
                return courseItemStatus.IN_PROGRESS;
            }
        }
        return courseItemStatus.NOT_STARTED;
    };
    const renderTree = (section, isRoot) => (_jsx(StyledTreeItem, { isRoot: isRoot, itemId: section.id, section: section, selectedItem: selectedItem, setSelectedItem: setSelectedItem, viewStatus: getViewStatus(section), showLessonType: showLessonType, children: Array.isArray(section.sections)
            ? section.sections.map((subSection) => renderTree(subSection, false))
            : null }, section.id));
    React.useEffect(() => {
        if (firstRender.current) {
            firstRender.current = false;
        }
        else {
            expansionAction.current = '';
        }
        const getAllIds = () => {
            const allIds = [];
            const loopSubSections = (arr) => arr.forEach((section) => {
                allIds.push(section.id);
                if (Array.isArray(section.sections) && section.sections.length > 0) {
                    loopSubSections(section.sections);
                }
            });
            loopSubSections(sections);
            return allIds;
        };
        setExpanded((lastExpanded) => {
            switch (expansionAction.current) {
                case 'allExpanded':
                    return getAllIds();
                case 'allCollapsed':
                    return [];
                case 'firstOpen':
                    return [sections[0]?.id].filter(Boolean);
                default:
                    return lastExpanded.length > 0 ? lastExpanded
                        : [sections[0]?.id].filter(Boolean);
            }
        });
    }, [sectionExpansionOption, sections]);
    const handleToggle = (e, nodeIds) => {
        setExpanded(nodeIds);
    };
    return (sections?.length > 0) ? (_jsx(SimpleTreeView, { "aria-label": "course sections tree view", expandedItems: expanded, sx: {
            minHeight: '100%',
            color: 'subNav.text.primary',
            paddingX: '16px',
        }, onExpandedItemsChange: handleToggle, 
        // onSelect={(nodeIds: string[]) => console.log('selected nodes => ', nodeIds)}
        selectedItems: selectedItem?.id || null, children: sections.map((section) => renderTree(section, true)) })) : null;
};
SectionsPanel.defaultProps = {
    settings: {
        defaultExpanded: true,
    },
};
SectionsPanel.meta = {
    group: 'hidden',
    name: 'Course sections panel',
    description: 'Component displays the sections panel in course view page.',
    props: [
        {
            key: 'course',
            name: 'Course',
            type: 'course', // note this is a special type recognized by the system
            description: 'The course to display information about',
        },
        {
            key: 'settings.sectionExpansionOption',
            name: 'Sections expanded',
            type: 'string',
            description: 'Choose how the lesson outline sections are displayed.',
        },
    ],
    defaultConfig: {
        type: 'component',
        component: 'SectionsPanel',
        props: {
            sections: '@course.sections',
            settings: {
                sectionExpansionOption: 'firstOpen',
            },
        },
    },
};
export default SectionsPanel;
//# sourceMappingURL=SectionsPanel.js.map